/**
 * Etiqueta de cada factura: de dónde nació y si sigue vigente.
 * Definido con la dueña el 10/09/2026: toda factura tiene UNA etiqueta.
 *   Matrícula  → la primera del programa, nació al matricular al estudiante
 *   Renovación → nació al cerrarse el ciclo anterior (a medianoche)
 *   Manual     → la creó la administración con "+ Nuevo pago" (cargo extra)
 *   Anulada    → en rojo; se sigue viendo para que el consecutivo saltado se
 *                explique solo, pero ya no suma en los reportes de dinero
 */
const STYLES = {
  enrollment: { label: "Matrícula", cls: "bg-sky-50 text-sky-800 border-sky-200",
    title: "Nació al matricular al estudiante en el programa" },
  renewal: { label: "Renovación", cls: "bg-violet-50 text-violet-800 border-violet-200",
    title: "Nació al cerrarse el ciclo anterior" },
  manual: { label: "Manual", cls: "bg-slate-100 text-slate-700 border-slate-300",
    title: "Cargo creado a mano desde «+ Nuevo pago»" },
};

export const OriginBadge = ({ payment }) => {
  if (payment?.is_annulled) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider bg-red-50 text-red-700 border border-red-300"
            title="Factura anulada: conserva su consecutivo pero no suma en los reportes de dinero">
        Anulada
      </span>
    );
  }
  const s = STYLES[payment?.origin] || STYLES.manual;
  // Una beca no se cobra: se distingue de un cobro normal de un vistazo.
  if (payment?.scholarship) {
    return (
      <span className="inline-flex items-center gap-1">
        <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border ${s.cls}`}
              title={s.title}>
          {s.label}
        </span>
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider bg-violet-100 text-violet-700 border border-violet-300"
              title={payment.scholarship_value
                ? `Beca: este ciclo se dio gratis (habría costado $${Number(payment.scholarship_value).toFixed(2)})`
                : "Beca: este ciclo se dio gratis"}>
          Beca
        </span>
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border ${s.cls}`}
          title={s.title}>
      {s.label}
    </span>
  );
};
